var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path3, _path4, _rect8, _rect9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0H9.49998H1.5V1.5H0V18H1.5H12.5V16.5H14V4.49999V3.99999L9.99998 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0H9.99998L14 3.99999V16.5H12.5V18H0V1.5H1.5V0ZM13.25 4.00001L9.99997 0.750018V4.00001H13.25ZM12 17.5H0.500051V2.00009H1.50005V16.5H12V17.5ZM1.99997 16H13.4999V4.50004H9.49995V0.500051H1.99997V16Z",
    fill: "#A6A6A6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 1.99997,
    width: 2.49999,
    height: 0.499999,
    fill: "#C8C8C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.99997,
    width: 8.49998,
    height: 0.499999,
    fill: "#C8C8C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 7.5,
    width: 8.49998,
    height: 0.499999,
    fill: "#C8C8C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.99994,
    width: 8.49998,
    height: 0.499999,
    fill: "#C8C8C8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 10.5,
    width: 8.49998,
    height: 0.499999,
    fill: "#C8C8C8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 12,
    width: 8.49998,
    height: 0.499999,
    fill: "#C8C8C8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 13.4999,
    width: 8.49998,
    height: 0.499999,
    fill: "#C8C8C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.50003V16.5H12H12.5V18H0V1.50003H1.5Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 0H9.49998H1.5V16.5H14V4.49999V3.99999L9.99998 0Z",
    fill: "url(#paint1_linear)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 16.4999,
    width: 11,
    height: 1.5,
    fill: "url(#paint2_linear)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 4.5,
    width: 3.99999,
    height: 1.5,
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -9.71551,
    y1: 12.6726,
    x2: 6.34267,
    y2: 24.4689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5E5E5E",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -62.1411,
    y1: 494.187,
    x2: 686.834,
    y2: 911.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5E5E5E",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 12.1608,
    y1: 17.9524,
    x2: 12.1608,
    y2: 16.5449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#303030",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 252.759,
    y1: 46.2149,
    x2: 252.759,
    y2: 37.7699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#828282",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#303030",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.ee9957ca08a5731fe86f8d3b6dbe285f.svg";
export { ForwardRef as ReactComponent };